import React from "react";
import LoadingSpinner from "../Utils/Spinner";
import { Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";


export default function VehicleFigures({vehiclesData, vehicleSummaryData, capData, vehiclesLoaded, vehicleSummaryLoaded, capLoaded}){

    if(!vehiclesLoaded || !vehicleSummaryLoaded || !capLoaded){
        return <LoadingSpinner/>
    }

    return (
        <div>
            <Title>Vehicles</Title>
            <Columns isMultiline>
                <Column>
                    <Table isBordered>
                        <thead>
                            <tr>
                                <th>HP Interest Accrued</th>
                                <th>HP Capital Repayments</th>
                                <th>Total Vehicle Finance</th>
                                <th>Total Hire Cost</th>
                                <th>Total Depreciation</th>
                                <th>Vehicle Tax</th>
                                <th>Total Vehicle Sales Cash Flow</th>
                                <th>Total Vehicle Sales Profit</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{vehiclesData && vehiclesData.total_hp_interest_accrued}</td>
                                <td>{vehiclesData && vehiclesData.total_capital_repayments}</td>
                                <td>{vehiclesData && vehiclesData.total_finance}</td>
                                <td>{vehiclesData && vehiclesData.total_hire_cost}</td>
                                <td>{vehiclesData && vehiclesData.total_depreciation}</td>
                                <td>{vehiclesData && vehiclesData.total_tax}</td>
                                <td>{vehiclesData && vehiclesData.total_sales_cash_flow}</td>
                                <td>{vehiclesData && vehiclesData.total_sales_profit}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Table isBordered>
                        <thead>
                            <tr>
                                <th>Total Cap Below</th>
                                <th>Total Cap Average</th>
                                <th>Total Cap Clean</th>
                                <th>Total Cap Retail</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{capData.total_cap_below}</td>
                                <td>{capData.total_cap_average}</td>
                                <td>{capData.total_cap_clean}</td>
                                <td>{capData.total_cap_retail}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Column>
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Table isBordered>
                        <thead>
                            <tr>
                                <th>Total Purchase Price</th>
                                <th>Total Depreciated Value</th>
                                <th>Total Monthly Payment</th>
                                <th>Total Annual Tax</th>
                                <th>Total Remaining Finance (Inc. Interest)</th>
                                <th>Total Remaining Capital</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{vehicleSummaryData.total_purchase_price}</td>
                                <td>{vehicleSummaryData.total_estimated_value}</td>
                                <td>{vehicleSummaryData.total_monthly_payment}</td>
                                <td>{vehicleSummaryData.total_tax}</td>
                                <td>{vehicleSummaryData.total_remaining_finance}</td>
                                <td>{vehicleSummaryData.total_remaining_capital}</td>
                            </tr>
                        </tbody>
                    </Table>
                </Column>
            </Columns>
        </div>
    );

}